/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 28.08.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import ClassNames from 'classnames';

import {RDVR_STATES} from '../../../../utils';
import {FetchAssetById} from '../../../../actions/asset/action-asset';

import Tooltip from 'rc-tooltip';
import Translate from '../../../Translate';

import moment from 'moment';
import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';

class NotificationTile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      channelLogo: `/images/${Config.white_skin ? 'white' : 'black'}/no-channel-logo.png`,
      momentTime: moment.unix(_get(this.props, 'notification.start'))
    }
  }

  componentWillMount() {
    _get(this.props, 'notification.channel_id') && this.props.FetchAssetById(_get(this.props, 'notification.channel_id'));

    if (this.props.channel.id) {

      lh.models.asset.methods.getPosterUrl(this.props.channel, {
        crop: {x: 30, y: 30},
        cache: false
      })
        .then((url) => {
          this.setState({channelLogo: url});
        }, () => {
        });
    }
  }

  componentWillReceiveProps(newProps) {

    if (_get(this.props, 'notification.channel_id') !== _get(newProps, 'notification.channel_id')) {

      this.props.FetchAssetById(_get(newProps, 'notification.channel_id'));
    }

    if (newProps.channel.id !== this.props.channel.id) {

      lh.models.asset.methods.getPosterUrl(newProps.channel, {
        crop: {x: 30, y: 30},
        cache: false
      })
        .then((url) => {
          this.setState({channelLogo: url});
        }, () => {
        });
    }

    this.setState({
      momentTime: moment.unix(_get(this.props, 'notification.start'))
    });
  }

  shouldComponentUpdate(nextProps, nextState) {

    return !_isEqual(_get(nextProps, 'notification', null), _get(this.props, 'notification', null))
      || this.props.isSelected !== nextState.isSelected
      || this.state.channelLogo !== nextState.channelLogo;
  }

  _hasSubTitle() {

    return _get(this.props, 'notification.title') !== _get(this.props, 'notification.program.title');
  }

  render() {
    let npvrTileClass = ClassNames({
      'col-last': this.props['col'] === 3,
      'movie block-2-half bg-black radius showcase-row-channel-block': true
    });

    return (
      <div className={npvrTileClass} onClick={this.props.onNotificationSelect.bind(this, this.props.notification, this.props.row, this.props.col)}>
        <a href="javascript:void(0)" className="profile-show hover" rel="profile-program">
          {this.props.isSelected && <ReactCSSTransitionGroup transitionName="selection-animation" transitionAppear={true} transitionAppearTimeout={0} transitionEnterTimeout={0} transitionLeaveTimeout={0}>
            <i className="ic ic-selected-dot ic-10px asset-selected-icon"></i>
          </ReactCSSTransitionGroup>}

          <span className="block-note-notification notification-icons">
          <i className="ic ic-notification ic-11px notification-state-icon"></i>
            <div className="notification-channel">
              <span className="title-notification-channel"> {this.props.channel.title} </span>
              <img src={this.state.channelLogo} className="ico-notification-channel" alt={_get(this.props, 'channel.title')} />
            </div>
          </span>
          <span className="block-note-notification notification-title"><b>{_get(this.props, 'notification.program.title')}</b></span>
          {this._hasSubTitle() && <span className="block-note-notification notification-subtitle">
            <span className="program-title color-grey">{_get(this.props, 'notification.title')}</span>
          </span>}
          <span className="block-note-notification notification-date"> {this.state.momentTime.format(_get(Config, 'notification.notification_time_format', 'HH:mm ddd, D MMM'))} </span>
        </a>
      </div>
    );
  }
}

NotificationTile.propTypes = {
  notification: PropTypes.object.isRequired,
  channel: PropTypes.object,
  onNotificationSelect: PropTypes.func.isRequired
};

const mapStateToProps = ({assets}, ownProps) => {
  let channel = _get(assets, _get(ownProps, 'notification.channel_id'));

  return {
    channel: channel || {}
  };
};

const mapDispatchToProps = (dispatch) => {

  return bindActionCreators({FetchAssetById}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationTile);



// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/Tile/Notification/notification-tile.js